import { render, staticRenderFns } from "./ApfUploadStudentPhoto.vue?vue&type=template&id=d7701efc&scoped=true"
import script from "./ApfUploadStudentPhoto.vue?vue&type=script&lang=js"
export * from "./ApfUploadStudentPhoto.vue?vue&type=script&lang=js"
import style0 from "./ApfUploadStudentPhoto.vue?vue&type=style&index=0&id=d7701efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7701efc",
  null
  
)

export default component.exports